import { NextPage } from 'next';
import { Fragment, useState } from 'react';
// -------- custom component -------- //
import { LocalSEO } from 'components/blocks/portfolio';
import NextLink from 'components/reuseable/links/NextLink';
import SEO from 'components/common/SEO';
import * as All from 'data/keywords';
import ProjectDetailsNavigation from 'components/common/ProjectDetailsNavigation';
import ContactFooterCombo from 'components/reuseable/ContactFooterCombo';

const details = {
  pageName: 'JJW',
  categories: 'multilingual seo',
  description:
    'JJW  is a chain of hotels around Europe. JJW approached us to conduct keyword research, develop the code and content templates to support multilingual SEO, helping them rank in the top results for international terms and local niches.',
  parentDirectories: 'seo-design-portfolio'
};

const Portfolio = All.InternationalSEOArrays[0].keywords;

const ProjectDetails: NextPage = () => {
  return (
    <Fragment>
      {/* <PageProgress /> */}{' '}
      <main className="content-wrapper">
        {/* ========== SEO META values ========== */}

        <SEO
          title={`${Portfolio[0].title} - ${details.pageName}`}
          description={details.description}
          tag={details.categories}
          urlPT={``}
          urlENPT={``}
          url={`${Portfolio[0].url}/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}`}
          image={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
        // updated=""
        // published=""
        // modified=""
        />

        {/* ========== heading section ========== */}
        <section
          className="wrapper  image-wrapper bg-image bg-overlay text-white"
          style={{
            backgroundImage: 'url(/img/clients/' + Portfolio[1].title.toLowerCase().replace(/ /g, '-') + '-bg.jpg)',
            backgroundSize: 'cover'
          }}
        >
          <div className="container pt-17 pb-12 pt-md-19 pb-md-16 text-center">
            <div className="row">
              <div className="col-md-10 mx-auto">
                <div className="post-header">
                  {/* <div className="post-category text-line text-white">
                    <NextLink title="Identity" href="#" className="text-reset" />
                  </div> */}
                  <h1 className="fs-15 text-uppercase text-white mb-3">{Portfolio[0].title}</h1>
                  <p className="display-4 text-capitalize mx-auto">{details.pageName}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="wrapper bg-light wrapper-border">
          {/* ========== details section ========== */}
          <div className="container pt-14 pt-md-16 pb-13 pb-md-15">
            <div className="row">
              <div className="col-lg-12 offset-lg-0">
                <h2 className="display-6 mb-4">{details.pageName}</h2>

                <div className="row">
                  <div className="col-md-8 text-justify">
                    <p style={{ clear: 'right' }}>
                      <img
                        width={120}
                        height={'auto'}
                        src={`/img/${All.localSEOPackages[1].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                        alt={All.localSEOPackages[1].title}
                        style={{ background: 'transparent', float: 'right' }}
                        className="mb-5 ms-3"
                      // align="right"
                      />
                      {/* <NextLinkNoAlt href={keywords[0].url} title={keywords[0].title} /> */}
                      {/* <br /> */}
                      <strong className="caption">{details.description}</strong>
                    </p>
                    <ul style={{ clear: 'right', maxWidth: 666 }}>
                      <li>Provided the technical SEO foundation for multiple websites within the JJW group.</li>
                      <li>Worked in
                        partnership with French content optimsation agency,{' '}
                        <a href="https://referencement.com/" target="_blank" rel="noreferrer">
                          R&eacute;f&eacute;rencement.com
                        </a>{' '}
                        to ensure that the websites' copy was optimized for search engines.</li>
                      <li>Conducted keyword
                        research and content optimisation ensuring that the copy on the websites was engaging and
                        informative while also being optimized for search engines.</li>
                    </ul>
                    <h2>{Portfolio[1].title}</h2>
                    <p>
                      As a result of collaborating with R&eacute;f&eacute;rencement.com, the websites within the JJW
                      group saw a dramatic improvement in their search engine rankings to the top of page 1 for multiple
                      desired keywords, local and national. The technical SEO foundation that we established helped to
                      ensure that the websites were properly optimized for search engines, while James's guidance on
                      keyword research and content optimisation helped to ensure that the websites' copy was engaging
                      and informative.
                    </p>
                    <p>
                      At SEOptimist, we understand the importance of collaboration and partnership when it comes to
                      providing effective SEO solutions. Whether you are working with an international SEO company or
                      managing multiple websites within a larger organization, our team of experts can provide the
                      technical SEO support and guidance you need to improve your search engine rankings and increase
                      your online visibility. <NextLink title="Contact" href="/#contact" className="" /> us today to
                      learn more about our SEO services.
                    </p>{' '}
                    {/* <NextLink title={All.HomeList[0].title} href="/" />
                    <NextLink title={All.HomeList[7].title} href="/" /> */}
                  </div>

                  <div className="col-md-4 ms-auto">
                    <img
                      width={'100%'}
                      height={'auto'}
                      src={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[0].title}
                      style={{ background: 'transparent' }}
                    />
                    <ul className="list-unstyled ms-7 mt-10">
                      <li>
                        <h5 className="mb-1">Categories</h5>
                        <p>{details.categories}</p>
                      </li>

                      <li>
                        <h5 className="mb-1">Client Name</h5>
                        <p>{details.pageName}</p>
                      </li>
                    </ul>
                  </div>
                  <NextLink title="Get in touch" href="/#contact" className="more hover" />
                  {/* ========== portfolio section ========== */}
                  <LocalSEO initialslide={0} />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <ContactFooterCombo location="london" />
    </Fragment>
  );
};

export default ProjectDetails;
